import React, { useEffect, useState } from 'react';
import './VehiclesPage.scss';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { isMobile } from 'react-device-detect';
import { useSearchParams } from 'react-router';
import TabMenu from '../../../components/base/TabMenu/TabMenu';
import VehiclesGrid from './VehicleGrid';
import VehiclesMap from './VehicleMap';
import {
  addGlobalPopUpWrapper,
  clearGlobalPopUpWrapper,
  closeAllPopupWrapper,
} from '../../InformationScreenWrapper/actions';
import { POPUP_LIST_NAME } from '../../../configs';
import TravelHistoryDialog from './TravelHistoryDialog';
import VehiclesSearchMap from './VehiclesSearchMap';
import MobileVehiclesSearchMap from './MobileVehiclesSearchMap';

export default function VehiclesPage() {
  const { formatMessage } = useIntl();
  const [selectedTab, setSelectedTab] = useState(1);
  const [showTravelDialog, setShowTravelDialog] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const vehicle_id = searchParams.get('vehicle_id');
  const dispatch = useDispatch();

  const handleOpenDetails = item => {
    dispatch((addGlobalPopUpWrapper({ window: POPUP_LIST_NAME.VEHICLE_REGISTRY_POP_UP, id: item.id })));
  };

  useEffect(() => {
    if (vehicle_id) {
      dispatch(closeAllPopupWrapper());
      dispatch((addGlobalPopUpWrapper({ window: POPUP_LIST_NAME.VEHICLE_REGISTRY_POP_UP, id: vehicle_id })));
    }
  }, [vehicle_id]);

  const handleShowHistory = item => setShowTravelDialog(item.id);

  return (
    <div className="page vehicles-page">
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'menu.vehicle.registry' })}</div>
        <div className="ms-auto vehicle-tabs-wrapper">
          <TabMenu options={[{ value: 1, label: 'Таблица' }, { value: 2, label: 'Карта' }, { value: 3, label: 'Поиск' }]} onSelectOptions={i => setSelectedTab(i.value)} selectedTab={selectedTab} />
        </div>
      </div>
      {selectedTab === 1 ? <VehiclesGrid handleOpenDetails={handleOpenDetails} handleShowHistory={handleShowHistory} /> : null}
      {selectedTab === 2 ? <VehiclesMap handleOpenDetails={handleOpenDetails} /> : null}
      {selectedTab === 3 && !isMobile ? <VehiclesSearchMap handleOpenDetails={handleOpenDetails} /> : null}
      {selectedTab === 3 && isMobile ? <MobileVehiclesSearchMap handleOpenDetails={handleOpenDetails} /> : null}
      {showTravelDialog ? <TravelHistoryDialog id={showTravelDialog} handleClose={() => setShowTravelDialog(null)} /> : null}
    </div>
  );
}
